const ITEMS = [
  "Interior Styling",
  "Spatial Curation",
  "Bespoke Sourcing",
  "Art & Objects",
  "Turnkey Residences",
];

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-gold/10 py-8 md:py-10"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
              <span key={`${half}-${item}`} className="flex items-center">
                <span className="font-serif italic font-light text-3xl md:text-5xl text-cream/75 whitespace-nowrap px-10">
                  {item}
                </span>
                <span className="text-gold/70 text-sm">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
